import "./ComplianceStatus.css";

const presentations = {
  "non-compliant": { label: "Violation", tone: "danger" },
  warning: { label: "Advisory", tone: "attention" },
  "on-target": { label: "Compliant", tone: "success" },
  compliant: { label: "Compliant", tone: "success" },
  "not-evaluated": { label: "Not evaluated", tone: "muted" }
};

export function ComplianceStatus({ status }) {
  const presentation = presentations[status] ?? presentations["not-evaluated"];
  return <span className={`compliance-status ${presentation.tone}`}>{presentation.label}</span>;
}
